export default __webpack_public_path__ + "static/media/chj3.1e205835.jpg";